import * as React from 'react';
import { Grid, SemanticWIDTHS, Table } from 'semantic-ui-react';
import { UpdateDataFileContainer } from '../../data-upload/update-data-file';
import { AILConfigOptions } from '../ail-config-options';
import { AILConfigActionsContainer } from '../ail-config-actions';
import { AILMappingOptions } from '../../../components';
import { IAppAILConfig, IColumns } from '../../../interfaces';
import { CONTROL_KEY, CONFIG_VIEW_TEXT, INDICATOR_KEY, PLAN_KEY } from '../../../constants';
import './ail-config-view.less';

/**
 * View for Activity-Indicator Links Config" component
 */
export class AILConfigView extends React.Component<IAILConfigViewProps> {
  public readonly MAX_COLUMNS: SemanticWIDTHS = 5;
  public readonly CONTENT_WIDTH: SemanticWIDTHS = 12;

  constructor(props: IAILConfigViewProps) {
    super(props);
  }

  public getConfigRows(): JSX.Element[] {
    const rows: JSX.Element[] = [];
    const colIndexes: string[] = Object.keys(this.props.columns);

    for (let i: number = 0; i < colIndexes.length; i++) {
      const colIndex: string = colIndexes[i];

      const row: JSX.Element = (
        <AILMappingOptions
          key={i}
          colIndex={colIndex}
          name={this.props.columns[colIndex]}
          activityEventConfig={this.props.appAILConfig.activityEventConfig}

          onWarningChange={this.props.onWarningChange}
          onMappingReset={this.props.onMappingReset}
          onActivityEventColMappingChange={this.props.onActivityEventColMappingChange}
        />
      );
      rows.push(row);
    }
    return rows;
  }

  public getTableHeader(): JSX.Element {
    const caption: string = CONFIG_VIEW_TEXT.AIL_FIELDS_CONFIG;

    return (
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell content={caption} colSpan={this.MAX_COLUMNS} />
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.STATUS_COLUMN_HEADER} />
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.COLUMN_NAME_HEADER} />
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.MAPPING_TYPE_HEADER} />
          <Table.HeaderCell content={CONFIG_VIEW_TEXT.FIELD_NAME_HEADER} />
        </Table.Row>
      </Table.Header>
    );
  }

  public getConfigTable(): JSX.Element {
    return (
      <Grid.Row columns="equal" centered>
        <Grid.Column width={this.CONTENT_WIDTH}>
          <Table celled compact columns={this.MAX_COLUMNS}>
            {this.getTableHeader()}

            <Table.Body>
              {this.getConfigRows()}
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    );
  }

  public getConfigActions(): JSX.Element {
    return (
      <Grid.Row columns="equal" centered>
        <Grid.Column width={this.CONTENT_WIDTH}>
          <AILConfigActionsContainer warning={this.props.warning} />
        </Grid.Column>
      </Grid.Row>
    );
  }

  public render(): JSX.Element {
    return (
      <Grid data-component="ail-config-view">
        <Grid.Row columns="equal" centered>
          <Grid.Column width={this.CONTENT_WIDTH}>
            <UpdateDataFileContainer />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row className="no-padding" columns="equal" centered>
          <Grid.Column width={this.CONTENT_WIDTH}>
            <AILConfigOptions />
          </Grid.Column>
        </Grid.Row>

        {this.props.optionsReady ? this.getConfigTable() : null}
        {this.props.optionsReady ? this.getConfigActions() : null}
      </Grid>
    );
  }
}

export interface IAILConfigViewProps {
  readonly columns: IColumns;
  readonly warning: boolean;
  readonly optionsReady: boolean;
  readonly appAILConfig: IAppAILConfig;

  onWarningChange(warning: boolean): void;
  onMappingReset(colIndex: string): void;
  onActivityEventColMappingChange(colIndex: string, key: PLAN_KEY | INDICATOR_KEY | CONTROL_KEY): void;
}
